/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const PinnedGroupsResponse = zod.object({
  groupUuids: zod
    .array(zod.uuid())
    .nullable()
    .describe(
      'The groups pinned to the desktop group rail, in rail order, leaving out any the user has since left. Null when the user has never chosen, which is not the same as pinning nothing.',
    ),
});

export type PinnedGroupsResponse = zod.input<typeof PinnedGroupsResponse>;
export type PinnedGroupsResponseOutput = zod.output<typeof PinnedGroupsResponse>;
